<template>
    <v-dialog v-model="$props.params.addRuleFromFilterAndAssignDomainToGroupDialog"
              max-width="600px"
              transition="dialog-bottom-transition" @keydown.esc="closeAddRuleFromFilterAndAssignDomainToGroupDialog()"
              @click:outside="closeAddRuleFromFilterAndAssignDomainToGroupDialog()">
        <v-card>
            <v-form @submit.prevent="processAddRuleFromFilterAndAssignDomainToGroupDialog()">
                <v-toolbar :class="dialogHeadingClasses()" color="primary" dark>
                    <v-icon class="mr-3" v-text="icons.mdiPlus"></v-icon>
                    {{ $gettext('Add to Rule/Group') }}
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" v-text="icons.mdiClose"
                            @click.native.stop="closeAddRuleFromFilterAndAssignDomainToGroupDialog()"></v-icon>
                    <v-icon v-text="icons.mdiContentSave"
                            @click.native.stop="processAddRuleFromFilterAndAssignDomainToGroupDialog()"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-3">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <h3 v-text="$gettext('Please choose a domain/subdomain level')"></h3>
                                <v-chip-group v-model="domainChoice" :error-messages="domainChoiceErrors" class="my-4"
                                              color="primary"
                                              column mandatory
                                              @blur="$v.domainChoice.$touch()" @input="$v.domainChoice.$touch()">
                                    <v-chip v-for="(domainDetails) in fullDomainDetails" :value="domainDetails?.key"
                                            v-text="domainDetails?.text"></v-chip>
                                </v-chip-group>

                                <v-select v-if="domainChoice" v-model="destination" :error-messages="destinationErrors"
                                          :items="destinationOptions"
                                          :label="$gettext('Choose Destination')" item-text="text" item-value="key"
                                          outlined
                                          required @blur="$v.destination.$touch()"
                                          @input="$v.destination.$touch()">
                                </v-select>

                                <v-autocomplete
                                    v-show="destination === 1" ref="ruleSearch" v-model="ruleToAdd"
                                    :error-messages="ruleToAddErrors" :item-text="'key'" :item-value="'key'"
                                    :items="rules" append-icon="mdi-magnify"
                                    class="search-rule-autocomplete" clearable
                                    label="Add to Rule"
                                    outlined
                                ></v-autocomplete>

                                <!-- :items="groups" :item-text="'key'"
                                    :item-value="'key'" label="Groups" -->
                                <v-autocomplete
                                    v-show="destination === 2" v-model="groupToAdd"
                                    :error-messages="groupToAddErrors"
                                    :item-text="item => item.group"
                                    :item-value="item => item.parent ? item.parent + '/' + item.group : item.group"
                                    :items="allGroupsForAutocomplete"
                                    :label="$gettext('Groups')"
                                    auto-select-first
                                    clearable
                                    outlined
                                >
                                    <template v-slot:selection="data">

                                        <p class="my-1">
                                            <v-icon v-if="data.item.parent" class="pr-2 "
                                                    color="primary" v-text="icons.mdiFolderOutline"></v-icon>
                                            <span v-if="data?.item?.parent" v-text="data.item.parent"></span>
                                            <v-icon v-if="data.item.parent" color="primary"
                                                    v-text="icons.mdiSlashForward"></v-icon>
                                            <span v-text="data?.item?.group"></span>
                                        </p>


                                    </template>
                                    <template v-slot:item="{ props, item, on, attrs }">

                                        <v-list-item
                                            :disabled="item.isMaster || item.isUpdatable"
                                            :subtitle="item?.parent"
                                            :title="item?.group"
                                            class="ml-4"
                                            dense
                                            v-bind="props"
                                            v-on="on"
                                        >

                                            <v-list-item-content
                                                :class="{'ml-4': item.group && item.parent}"

                                            >

                                                <!-- Group name -->
                                                <v-list-item-title
                                                    v-if="item.group"
                                                    class="d-flex"

                                                >
                                                    <v-icon class="mr-2" small
                                                            v-text="icons.mdiSelectGroup"></v-icon>
                                                    <span class="text-caption text--lighten-2">{{ item.group }}</span>
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    <span v-if="item.parent.length"
                                                          class="text-caption text--lighten-2">
                                                        <v-icon class="mr-2" small
                                                                v-text="icons.mdiFolderOutline"></v-icon>
                                                        {{ item.parent }}
                                                    </span>
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>

                                </v-autocomplete>

                                <!--                                <v-text-field
                                                                    label="Device Name"
                                                                    required
                                                                    placeholder="Device Name"
                                                                    v-model="editDeviceName"
                                                                    :error-messages="editDeviceNameErrors"
                                                                    outlined
                                                                    @input="$v.editDeviceName.$touch()"
                                                                    @blur="$v.editDeviceName.$touch()"
                                                                    autofocus
                                                                    clearable
                                                                ></v-text-field>-->

                                <!--                                <v-text-field
                                                                    label="Mac"
                                                                    required
                                                                    placeholder="Mac"
                                                                    v-model="mac"
                                                                    :error-messages="macErrors"
                                                                    outlined
                                                                    @input="$v.mac.$touch()"
                                                                    @blur="$v.mac.$touch()"
                                                                    clearable
                                                                ></v-text-field>-->

                                <!--                                <v-switch
                                                                    required
                                                                    placeholder="Status"
                                                                    v-model="active"
                                                                    outlined
                                                                    :label=" active ? 'Active' : 'Inactive'"
                                                                ></v-switch>-->
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click.native.stop="closeAddRuleFromFilterAndAssignDomainToGroupDialog()">
                        {{ $gettext('Close') }}
                    </v-btn>
                    <v-btn class="primary" type="submit">
                        {{ $gettext('Save') }}
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}
</style>

<script>

import Vue from 'vue'
import {find, findIndex} from 'lodash'

import Vuelidate from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import {mapState, mapWritableState, storeToRefs} from 'pinia'
import {useRulesStore} from '@/stores/RulesStore'
import MixinConfigGroups from '@/mixins/database/MixinConfigGroups'
import MixinConfigRules from '@/mixins/database/MixinConfigRules'
import constants from '@/assets/js/constants'
import {useGroupsStore} from '@/stores/GroupsStore'

Vue.use(Vuelidate)

export default {
    components: {Snackbar},
    mixins: [MixinConfigGroups, MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigRules],
    props: {
        params: {
            required: true,
            type: Object,
        }
    },
    watch: {
        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        // TODO: Is this required?
    },
    mounted() {

        let self = this

        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        // TODO: Remove the unnecessary variables here such as the following.
        self.editDeviceName = self.$props.params.deviceName
        self.mac = self.$props.params.mac
        self.active = self.$props.params.active
        self.getFullDomainSubDomainDetails()

        self.subscribeToGroupsStoreAndGetChangesForAllGroupsForAutocomplete();
    },
    data() {
        return {
            destination: '',
            editDeviceName: '',
            mac: '',
            active: '',
            fullDomainDetails: {},
            ruleToAdd: '',
            groupToAdd: '',
            domainChoice: '',
            destinationOptions: [
                {key: 1, text: 'Add to Rule'},
                {key: 2, text: 'Add to Group'},
            ],
            allGroupsForAutocomplete: []
        }
    },

    methods: {

        getFullDomainSubDomainDetails() {

            let self = this

            let fullDomainDetails = this.$props.params.item.domain.split('.')

            let tld = fullDomainDetails.pop()
            let domainName = fullDomainDetails.pop()

            let temp = []

            for (let i = fullDomainDetails.length; i > 0; i--) {

                let subDomainString = ''

                subDomainString += fullDomainDetails[i - 1]

                // do not loop for the first item in the array
                if (i < fullDomainDetails.length) {

                    // loop through all the sub, sub sub, sub sub sub, domains and generate the string
                    // e.g. news.yahoo.com, paris.news.yahoo.com, today.paris.news.yahoo.com, etc.
                    for (let j = i; j < fullDomainDetails.length; j++) {
                        subDomainString += '.' + fullDomainDetails[j]
                    }
                }

                // + ' (Sub domain only)'
                temp.push({
                    key: i,
                    text: subDomainString + '.' + domainName + '.' + tld
                })

                // + ' (Sub domain and below)'
                temp.push({
                    key: i + 'b',
                    text: '*.' + subDomainString + '.' + domainName + '.' + tld
                })

            }

            self.fullDomainDetails = temp.reverse()

            if (domainName) {
                self.fullDomainDetails.push({
                    key: 'd',
                    text: '*.' + domainName + '.' + tld + ' ' + constants.fullAccessText
                })
            }

        },

        processAddRuleFromFilterAndAssignDomainToGroupDialog() {

            let self = this

            self.$v.$touch()

            if (!self.$v.$invalid) {

                let successText
                let warningText

                let domain = self.fullDomainDetails.find(item => item.key === self.domainChoice)
                let destination = self.destinationOptions.find(item => item.key === self.destination)

                switch (destination.key) {

                    case 1:

                        if (self.configRulesHasDomainInDestDomainsAlready(self.ruleToAdd, domain.text)) {
                            warningText = self.$gettext('%{ domainText } is already in %{ ruleToAdd }!')
                        } else {
                            self.configRulesPushToRuleDestDomains(self.ruleToAdd, domain.text)
                            successText = self.$gettextInterpolate(self.$gettext('%{ domainText } added to %{ ruleToAdd } successfully!', {
                                domainText: domain.text,
                                ruleToAdd: self.ruleToAdd
                            }))
                        }

                        break

                    case 2:

                        domain.text = domain.text.replaceAll(' (Full Access)', '')
                        domain.text = domain.text.replaceAll('(Full Access)', '')

                        if (self.configGroupsHasDomainInDestDomainsAlready(self.groupToAdd, domain.text)) {

                            warningText = self.$gettext('%{ domainText } is already in %{ groupToAdd }!')
                            warningText = self.$gettextInterpolate(warningText, {
                                domainText: domain.text,
                                groupToAdd: self.groupToAdd
                            })

                        } else {

                            if (self.groupToAdd.includes('/')) {
                                let [folder, group] = self.groupToAdd.split('/')
                                let groupRow = self.groups.find(g => g.key === folder);
                                let childRow = groupRow.child.find(c => c.key === group);
                                childRow.value.dest_domains.push(domain.text)
                            } else {
                                let groupRow = self.groups.find(g => g.key === self.groupToAdd);
                                groupRow.value.dest_domains.push(domain.text)
                            }

                            successText = self.$gettext('%{ domainText } is added to %{ groupToAdd } successfully!')
                            successText = self.$gettextInterpolate(successText, {
                                domainText: domain.text,
                                groupToAdd: self.groupToAdd
                            })

                        }

                        break
                }

                if (successText) {
                    self.$parent.$refs.snackbar.showSnackbar(successText, 'secondary')
                } else if (warningText) {
                    self.$parent.$refs.snackbar.showSnackbar(warningText, 'warning')
                }

                self.closeAddRuleFromFilterAndAssignDomainToGroupDialog()

                return false

            } else {
                // Please resolve the form errors
            }

        },

        closeAddRuleFromFilterAndAssignDomainToGroupDialog() {
            let self = this
            self.$parent.closeDialog('addRuleFromFilterAndAssignDomainToGroupDialog')
        },
        resetForm() {
            let self = this
            self.$v.$reset()
            self.editDeviceName = ''
        },

        subscribeToGroupsStoreAndGetChangesForAllGroupsForAutocomplete() {

            let self = this;

            useGroupsStore().$subscribe((mutation, state) => {
                self.setAllGroupsForAutocomplete();
            })

            self.setAllGroupsForAutocomplete();

        },

        setAllGroupsForAutocomplete() {

            const parentGroupObj = (parent, group, isMaster, isUpdatable) => ({parent, group, isMaster, isUpdatable});

            this.allGroupsForAutocomplete = this.groups.flatMap(value => {

                if (value.hasOwnProperty('child')) {
                    return value.child.map(childValue => {
                        return parentGroupObj(value.key, childValue.key, childValue['value']['@master'] || false);
                    });
                } else {
                    return parentGroupObj(false, value.key, value['value']['@master'] || false, value['value']['@updatable'] || false);
                }
            });

        }

    },
    computed: {

        // Some are inside MixinConfigGroups, MixinConfigRules

        domainChoiceErrors() {
            const errors = []
            if (!this.$v.domainChoice.$dirty) return errors
            !this.$v.domainChoice.required && errors.push(this.$gettext('This field is required.'))
            return errors
        },

        destinationErrors() {
            const errors = []
            if (!this.$v.destination.$dirty) return errors
            !this.$v.destination.required && errors.push(this.$gettext('Destination is required.'))
            return errors
        },
        ruleToAddErrors() {
            const errors = []
            if (!this.$v.ruleToAdd.$dirty) return errors
            !this.$v.ruleToAdd.required && errors.push(this.$gettext('Rule is required.'))
            return errors
        },
        groupToAddErrors() {
            const errors = []
            if (!this.$v.groupToAdd.$dirty) return errors
            !this.$v.groupToAdd.required && errors.push(this.$gettext('Group is required.'))
            return errors
        },

        ...mapWritableState(useGroupsStore, {
            groups: 'groups',
        })

    },
    validations: {
        domainChoice: {
            required,
        },
        destination: {
            required,
        },
        ruleToAdd: {
            required: requiredIf(function (vm) {
                return (vm?.destination === 1)
            })
        },
        groupToAdd: {
            required: requiredIf(function (vm) {
                return (vm?.destination === 2)
            })
        },
    }

}
</script>
